import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/**
 * The app uses the hash location strategy, so query params placed before the hash
 * (e.g. /?node=P4303) are not part of the router URL. They are also lost outright:
 * `<base href="./">` makes the document base URL query-less, and the router's
 * `history.replaceState(state, '', '#/')` resolves that relative URL against the
 * base, rewriting /?node=P4303 to /#/ before any component runs.
 *
 * Moving the query into the hash before bootstrap keeps the params and lets the
 * router expose them through ActivatedRoute as usual.
 */
function moveQueryParamsIntoHash(): void {
  const { search, hash } = window.location;

  if (!search || search === '?' || hash.includes('?')) {
    return;
  }

  const url = new URL(window.location.href);
  const routePath = url.hash && url.hash !== '#' ? url.hash : '#/';

  url.hash = routePath + url.search;
  url.search = '';

  // An absolute URL is required here: a relative one would resolve against the
  // document base href and drop the params again.
  window.history.replaceState(window.history.state, '', url.toString());
}

moveQueryParamsIntoHash();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
